import { Plus } from "lucide-react";
import { useState } from "react";

import { PageHeader, SectionHeader } from "@/components/shared/page-header";
import { Button } from "@/components/ui/button";
// Disabled for now — see the commented-out "Channel Notifikasi" section below.
// import { NotificationChannelsCard } from "@/pages/settings/workspaces/notification-channels-card";

import { AddConnectionDialog } from "./add-connection-dialog";
import { SenderConnections } from "./sender-connections";

export function NotificationsPage() {
  const [addOpen, setAddOpen] = useState(false);
  const [qrDeviceId, setQrDeviceId] = useState<string | null>(null);

  return (
    <div className="space-y-8">
      <PageHeader
        title="Notifikasi"
        description="Kelola koneksi pengirim (WhatsApp, Email, Resend) dan channel tujuan notifikasi, semua di satu halaman."
      />

      <div>
        <SectionHeader
          title="Koneksi Pengirim"
          description="Akun/nomor yang mengirim notifikasi keluar."
          action={
            <Button size="sm" onClick={() => setAddOpen(true)}>
              <Plus className="mr-1.5 h-4 w-4" />
              Tambah
            </Button>
          }
        />
        <SenderConnections
          qrDeviceId={qrDeviceId}
          onQrDeviceChange={setQrDeviceId}
        />
      </div>

      {/* Disabled for now
      <div>
        <SectionHeader
          title="Channel Notifikasi"
          description="Channel tujuan notifikasi (WhatsApp/Email) global — berlaku di seluruh workspace, hanya workspace utama yang bisa mengelolanya."
        />
        <NotificationChannelsCard />
      </div>
      */}

      <AddConnectionDialog
        open={addOpen}
        onOpenChange={setAddOpen}
        onWhatsappAdded={setQrDeviceId}
      />
    </div>
  );
}
